import { FormFieldNew } from './FormFieldNew';
import { useEntityForm } from '../EntityFormProvider';

type ProfileFormFieldProps = {
  entityType: string;
  fieldName: string;
  label?: string;
  index?: number;
};

export function ProfileFormField({ entityType, fieldName, label, index }: ProfileFormFieldProps) {
  const { form, entitiesMetadata, isEditing } = useEntityForm();

  const metadata = entitiesMetadata[entityType]?.[fieldName];
  if (!metadata) return null;

  return (
    <FormFieldNew
      form={form}
      parentFieldName={index !== undefined ? `${entityType}.${index}` : entityType}
      fieldName={fieldName}
      entityMetadata={metadata}
      label={label}
      isEditing={isEditing}
    />
  );
}
